import {
  AMS_URL,
  ENV,
  BENEFIT_URL,
  LOGIN_URL,
  ORDER_HOST,
  REPORT_URL,
  SERVER_URL,
  NODE_SERVER_URL,
  GATEWAY_URL,
} from 'lib/constants/domain';
import { currentUrlParams } from 'lib/utils/url';

let env = process.env.API_ENV || ENV.PRODUCTION;
if (process.env.IS_EDITOR) {
  env = currentUrlParams.getCurrentParams('apiEnv') || ENV.PRODUCTION;
}

export const config = {
  env,
};

export const urlConfig = {
  orderPageUrl: ORDER_HOST[env],
  benefitUrl: BENEFIT_URL[env],
  amsUrl: AMS_URL[env],
  loginUrl: LOGIN_URL[env],
  baseUrl: SERVER_URL[env],
  reportUrl: REPORT_URL[env],
  nodeUrl: NODE_SERVER_URL[env],
  gatewayUrl: GATEWAY_URL[env],
};
